import {Button, DirectionalIcon} from '@sollapay/ui/components';

import {useOverflowTitle} from '@/hooks';

import type {FC} from 'react';

export interface TrustAccountCtaButtonProps {
  label: string;
  onAction: () => void;
}

/** The list's revealed call to action; its click never reaches the row or card underneath. */
export const TrustAccountCtaButton: FC<TrustAccountCtaButtonProps> = ({label, onAction}) => {
  const {onMouseEnter: showTitleIfCutOff} = useOverflowTitle<HTMLSpanElement>(label);

  return (
    <Button
      size="sm"
      icon={<DirectionalIcon name="chevron-forward" className="size-3.5" />}
      className="max-w-full min-w-0 shrink whitespace-nowrap"
      onClick={event => {
        event.stopPropagation();
        onAction();
      }}
    >
      <span data-slot="label" className="truncate" onMouseEnter={showTitleIfCutOff}>
        {label}
      </span>
    </Button>
  );
};
